import axios from "./axiosInstance";

const AllTripsAPI = {
  getAllTrips: () => axios.get(`/alltrips`),
  getAllOverTrips: () => axios.get(`/allovertrips`),
  getSpecialTrips: (params) => axios.post(`/weekendtrips`, params),
};

export default AllTripsAPI;